import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
// import PropTypes from 'prop-types';
import { formatIntegrationModuleList } from '../../flux/action/projects';
import ManageForm from '@modules/projects/integrationHub/manageModules/manageMForm';
// import { List } from 'appkit-react';
// import actions from '@flux/action';
// import {getValueFromSearchParam} from "@utils";

function NavigationTiles({ addModuleConfig, navigatorData, cRef, formChange }) {
  // const dispatch = useDispatch();
  const tabs = navigatorData.integrationTabs || [];
  const { currentTab } = useSelector(({ projects: { projectDetail } }) => ({
    // integrationModuleData: formatIntegrationModuleList(tabs) || [],
    // tabs,
    // integrationNavigatorName: navigatorData.name,
    // type: navigatorData.type,
    // currentTab: navigatorData.currentTab,
    currentTab: projectDetail.currentTab || tabs[0]?.id || 'Home',
  }));

  const data = useMemo(
    () => ({
      ...formatIntegrationModuleList(tabs),
      integrationNavigatorName: navigatorData.name,
      displayMode: navigatorData.displayMode
        ? navigatorData.displayMode
        : 'List',
      type: navigatorData.type,
      // currentTab: navigatorData.currentTab,
      currentTab,
    }),
    [tabs, navigatorData],
  );

  return (
    <div className="manage-module-wrapper nav-wrapper">
      <ManageForm
        {...data}
        displayMode={data.displayMode ? data.displayMode === 'List' : true}
        initialIsSellSide={true}
        customSaveData={true}
        afterSaveData={() => {}}
        goBack={() => {}}
        refetch={() => {}}
        showSpn
        cRef={cRef}
        configs={{ addModuleConfig }}
        ratioNeedFullSize
        formChange={formChange}
        wrapperContainerClass=".nav-wrapper"
      />
    </div>
  );
}

NavigationTiles.propTypes = {};

export default memo(NavigationTiles);
